import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es en papel o digital?',
  a: 'Es 100% digital. Recibís todo de forma inmediata en tu correo, listo para usar, imprimir o completar en pantalla.'
}, {
  q: '¿Necesito experiencia previa para usarlo?',
  a: 'No. Está diseñado para que cualquier psicólogo pueda abrirlo y empezar desde el primer día.'
}, {
  q: '¿Sirve para cualquier orientación teórica?',
  a: 'Sí. El contenido es operativo y administrativo, no clínico-teórico. Sirve sin importar tu orientación.'
}, {
  q: '¿Qué pasa si ya tengo algunos documentos armados?',
  a: 'El kit complementa lo que ya tenés y cubre los vacíos que todavía no resolviste.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'De forma inmediata. En el momento en que confirmás tu pago, recibís el acceso completo en tu correo.'
}, {
  q: '¿Sirve si recién me recibí?',
  a: 'Es ideal para empezar bien desde el principio y ahorrarte meses de prueba y error en la gestión.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-20 bg-transparent pt-[30px] pb-[30px]" data-id="element-33">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-34">
        <div className="text-center mb-10 md:mb-12" data-id="element-35">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#566049] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-36">
            Preguntas Frecuentes
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#2f3a2c] leading-tight" data-id="element-37">
            Respondemos a{' '}
            <em className="text-[#c06a52] not-italic font-bold italic" data-id="element-38">
              tus preguntas
            </em>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-2xl shadow-sm shadow-black/5" data-id="element-40">
                <button className="w-full px-6 md:px-8 py-5 md:py-6 text-left flex justify-between items-center gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-41">
                  <span className="font-heading font-bold text-[#2f3a2c] text-lg md:text-xl" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className="flex-shrink-0 w-9 h-9 rounded-full bg-[#566049] text-white flex items-center justify-center transition-colors" aria-hidden="true" data-id="element-43">
                    {isOpen ? <Minus className="w-4 h-4" data-id="element-44" /> : <Plus className="w-4 h-4" data-id="element-45" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-46">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-47">
                      <div className="px-6 md:px-8 pb-6 md:pb-7 -mt-1 text-slate-600 leading-relaxed text-[15px] md:text-base max-w-[58ch]" data-id="element-48">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}